import React, { useEffect, useState } from 'react';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import { hasChildren } from "./utils";
import SingleLevel from './SingleLevel';
import "./MultiLevel.css";

export const MenuItem = ({ item, setskin_menu }) => {
   // console.log('MenuItem called....')
   const Component = hasChildren(item) ? MultiLevel : SingleLevel;
   return <Component setskin_menu={setskin_menu} item={item} />;
};
export const MultiLevel = ({ item, setskin_menu }) => {
   const [orentation, setOrentation] = useState((window.mob || window.isipad) && window.innerHeight > window.innerWidth ? 0 : 90)
   const { items: children } = item;
   const [open, setOpen] = useState(false);
   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';
   useEffect(() => {

      if (item.id === "Exterior") {
         document.getElementById("Exterior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Exterior").classList.add('MuiCollapse-entered');
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.add('menuActive');
      }
      document.getElementById("Exterior").previousSibling.classList.add('mainMenuAccordion');
      document.getElementById("Interior").previousSibling.classList.add('mainMenuAccordion');
      document.getElementById("menubtnxr").previousSibling.classList.add('mainMenuAccordion');


      if (window.innerHeight > window.innerWidth) {
         setOrentation(90);

      } else {
         setOrentation(0);
      }
   }, []);

   const handleClick = (menuname) => {     
      var menuTitle = item.title;        
      console.log(menuTitle,  window.configProduct.name);
      // window.RT_RecordEvent(menuTitle, window.configProduct.name); 
      const leftMenu_patch = document.getElementById("leftMenu");
      leftMenu_patch.style.backgroundColor = "rgba(0, 0, 0, 0.16)";
      leftMenu_patch.style.transition = "all 2s";
      if(window.mob){
         window.scene._nav._navPanSpeed = 0.2
      }
      if (!window.menuClick) return;
      window.currentPosition = '';
      window.hidePopUp();
      window.hideAllPopup();
      window.hideActivePopup();
      clearInterval(window.Interval1);
      clearInterval(window.Interval2);
      window.scene._fDoFFarAperture = 0;
      window.scene._fDoFNearAperture = 0;
      document.getElementById("right_port").classList.remove('active');
      document.getElementById("left_port").classList.add('active');
      var getBodyTag = document.getElementsByTagName("body")[0];
      var getBodyClass = getBodyTag.classList.contains('desktopdevice');
      if (!window.mob || (window.isipad && window.innerWidth > window.innerHeight) || getBodyClass) {
         var exteriorMenu = document.querySelector("#Exterior .MuiList-root");
         var exteriorMenuHeight = exteriorMenu.clientHeight;
         var menuInterior = document.querySelector("#menuInterior .MuiList-root");
         var menuInteriorHeight = menuInterior.clientHeight;
      }

      if (window.mob || (window.isipad && window.innerHeight > window.innerWidth)) {
         const mob_skin_icon = document.getElementsByClassName("mob_skin_icon");
         for (let i = 0; i < mob_skin_icon.length; i++) {
            mob_skin_icon[i].style.display = 'none';
            mob_skin_icon[i].classList.remove('active');
         }
         setskin_menu(false);
      }
      if (menuname === 'Exterior') {
         // window.reverseAnimation();
         window.scene._nav.SetRotationCenter([0,0,0]);
         if (document.getElementById("intel_ultra_logo") != undefined) document.getElementById("intel_ultra_logo").style.display = "block";
         // if (document.getElementById("recycled_elements_popup_two") != undefined) document.getElementById("recycled_elements_popup_two").style.display = "none";
         let hotspotsActive = [...document.querySelectorAll(".hotspots")];
         hotspotsActive.forEach(ele => {
            ele.style.display = "flex";
         });
        

         if (!window.mob || (!window.isipad && window.innerHeight > window.innerWidth) || getBodyClass) {
            document.getElementById('Interior').style.height = "0px";
            document.getElementById('Exterior').style.height = exteriorMenuHeight + "px";
         }
         window.hideAllPopup();
         // window.fRotMinLimitVal = 0.20;
         if (window.mob || window.isipad) {
            setTimeout(() => {
               if (document.querySelector('.MuiCollapse-wrapper')) {
                  document.querySelectorAll('.MuiCollapse-wrapper').forEach(wrapeer => wrapeer.scrollTo({ behavior: 'smooth', top: 0 }))
               }
            }, 500);
         }
         if (document.getElementById("FullDesktop") != null) document.getElementById("FullDesktop").classList.add('active');
         if (document.getElementById("TopDesktop") != null) document.getElementById("TopDesktop").classList.remove('active');
         document.getElementById("Exterior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Exterior").classList.add('MuiCollapse-entered');
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").previousSibling.classList.remove('menuActive');
         document.getElementById("Exterior").previousSibling.classList.add('menuActive');
         if (window.selectedMenu.cameraType != 'exterior') { window.fadeIn(window.reset) }
         else { window.reset() }
         window.selectedMenu.cameraType = 'exterior';
         // window.scene.groupApplyState("Premium_Suite_Keyboard");
         window.scene.groupApplyState("GP_ON");         
         // window.scene.groupApplyState("reflection_plane_90D")      
         window.scene.groupApplyState("Ref_ON");
         window.scene.groupApplyState("ON");       
      
         window.GotoPosInTimeNamedValue('Render_Cam_Reset_F90', function () {
            if (window.mob || window.isipadPortrait) {
               if (document.getElementById("exterior_text_mob") != undefined) document.getElementById("exterior_text_mob").style.display = "block";  
         }
         else {
            setTimeout(() => {
               if (document.getElementById("exterior_title") != undefined) document.getElementById("exterior_title").style.display = "block";
               if (document.getElementById("exterior_powered_logo") != undefined) document.getElementById("exterior_powered_logo").style.display = "block";
               if (document.getElementById("exterior_copilot_logo") != undefined) document.getElementById("exterior_copilot_logo").style.display = "block";
               if (document.getElementById("exterior_text_mob") != undefined) document.getElementById("exterior_text_mob").style.display = "none";
            }, 1000);

         } 
            window.selectedMenu.active = 'Render_Cam_Reset_F90';
            window.scene.setMaterialTransition(true, false, 500);
            window.scene.groupApplyState("Premium_Suite_Keyboard");
            window.scene.groupApplyState("reflection_plane_90D"); 
            // window.scene._nav.SetRotationCenter([-0.359097332, 14.053702082862282, 13.7064012632945049]);
            window.scene._nav.SetRotationCenter([-0.359097332, 14.053702082862282, 10.7064012632945049]);
            window.scene.clearRefine();
         });
         window.scene.animPlayAllChildrenInTime("LE_2263_Yoga_Slim_7X_QC", 90, 1000);
         window.scene.animPlayAllChildrenInTime("LE_2263_Yoga_Slim_7X_QC_01", 90, 1000);
         window.scene.animPlayAllChildrenInTime("RIGHT_SPEAKER", 30, 1);
            window.scene.animPlayAllChildrenInTime("SPEAKER", 30, 1);
            window.scene.animPlayAllChildrenInTime("RIGHT_SPEAKER_NEW", 30, 1);
            window.scene.animPlayAllChildrenInTime("LEFT_SPEAKER_NEW", 30, 1);
         window.scene.animPlayAllChildrenInTime("SCREEN", 90, 1000);
         window.scene.animPlayAllChildrenInTime("SCREEN.002", 90, 1000);
         setTimeout(window.fadeOut, 900);
         const content1 = document.getElementsByClassName("content1");
         for (let i = 0; i < content1.length; i++) {
            content1[i].style.maxHeight = null;
         }
         window.navLimits.minDolly = 44;
         window.navLimits.maxDolly = 200;
         window.navLimits.panLeft = 16;
         window.navLimits.panRight = -30;
         window.navLimits.panTop = -15;
         window.navLimits.panBottom = 25;
         window.updateZoombar(106, 123);
         window.scene.clearRefine();
      }
      else if (menuname === 'Interior') {
         const leftMenu_patch = document.getElementById("leftMenu");
         leftMenu_patch.style.backgroundColor = "rgba(0, 0, 0, 0.16)";
         leftMenu_patch.style.transition = "all 2s";
         window.scene._nav.SetRotationCenter([0,0,0]);
         // if (document.getElementById("recycled_elements_popup_two") != undefined) document.getElementById("recycled_elements_popup_two").style.display = "none";
         if (document.getElementById("intel_ultra_logo") != undefined) document.getElementById("intel_ultra_logo").style.display = "none";
         let hotspotsActive = [...document.querySelectorAll(".hotspots")];
         hotspotsActive.forEach(ele => {
            if (ele) {
               ele.style.display = "none";
            }
         });
         if (window.mob || window.isipad) {
            setTimeout(() => {
               if (document.querySelector('.MuiCollapse-wrapper')) {
                  document.querySelectorAll('.MuiCollapse-wrapper').forEach(wrapeer => wrapeer.scrollTo({ behavior: 'smooth', top: 0 }))
               }
            }, 500);
         }
         if (window.mob || window.isipadPortrait) {
            if (document.getElementById("exterior_text_mob") != undefined) document.getElementById("exterior_text_mob").style.display = "none";
         } else {
            if (document.getElementById("exterior_title") != undefined) document.getElementById("exterior_title").style.display = "none";
            if (document.getElementById("exterior_powered_logo") != undefined) document.getElementById("exterior_powered_logo").style.display = "none";
   if (document.getElementById("exterior_copilot_logo") != undefined) document.getElementById("exterior_copilot_logo").style.display = "none";
            if (document.getElementById("exterior_text_mob")) document.getElementById('exterior_text_mob').style.display = 'none';
         }
         window.hideAllPopup();
         if (!window.mob || (!window.isipad && window.innerHeight > window.innerWidth) || getBodyClass) {
            document.getElementById('Exterior').style.height = "0px";
            document.getElementById('Interior').style.height = menuInteriorHeight + 20 + "px";
         }
         document.getElementById('Exterior').style.height = "0px";
         window.scene.setMaterialTransition(true, false, 500);
         window.scene.groupApplyState("Processor");
         window.scene.groupApplyState("ON");
         window.scene.groupApplyState("CPU_ON");
         window.scene.groupApplyState("GP_OFF");              
         window.scene.groupApplyState("Ref_OFF");
         document.getElementById("Interior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Exterior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").classList.add('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.remove('menuActive');
         document.getElementById("Interior").previousSibling.classList.add('menuActive');
         window.animStoped = false;
         if (window.selectedMenu.cameraType != 'interior') { window.fadeIn(window.interiorClick); }
         else { window.interiorClick() }
         // window.fadeIn(window.interiorClick);

         window.selectedMenu.cameraType = 'interior';
         window.GotoPosInTimeNamedValue("Render_Cam_Explode_F220", (function () {
            window.selectedMenu.active = 'Render_Cam_Explode_F220';

         }));
         setTimeout(() => {
            window.scene.animPlayAllChildrenInTime("RIGHT_SPEAKER", 30, 1);
            window.scene.animPlayAllChildrenInTime("SPEAKER", 30, 1);
            window.scene.animPlayAllChildrenInTime("RIGHT_SPEAKER_NEW", 30, 1);
            window.scene.animPlayAllChildrenInTime("LEFT_SPEAKER_NEW", 30, 1);
            // window.scene.groupApplyState("Ref_OFF")
            window.scene.groupApplyState("INTERNAL_ON");
            window.scene.animPlayInTime("LE_2263_Yoga_Slim_7X_QC", 220, 1);
            window.scene.animPlayInTime("SCREEN", 90, 1)
            window.scene.animPlayAllChildrenInTime("KEYS", 100, 1);
            window.scene.animPlayAllChildrenInTime("D_COVER", 220, 1);
            window.scene.animPlayAllChildrenInTime("TOUCH_Pad", 100, 1);
            window.scene.animPlayAllChildrenInTime("BATTERY", 220, 1);
            window.scene.animPlayAllChildrenInTime("FAN2", 220, 1);
            window.scene.animPlayAllChildrenInTime("MOTHERBOARD", 220, 1);
            window.scene.animPlayAllChildrenInTime("THERMAL", 220, 1);            
         }, 500);
         // window.scene.clearRefine();
         setTimeout(window.fadeOut, 700)
         window.navLimits.minDolly = 53;
         window.navLimits.maxDolly = 230;
         window.navLimits.panLeft = 20;
         window.navLimits.panRight = -22;
         window.navLimits.panTop = 2;
         window.navLimits.panBottom = 43;
         window.updateZoombar(109, 124);

         const content2 = document.getElementsByClassName("content1");
         for (let i = 0; i < content2.length; i++) {
            content2[i].style.maxHeight = null;
         }

         // window.RT_RecordEvent("Explode","Explode View",window.configProduct.name);
         window.scene.clearRefine();
      }

      else {
         document.getElementById("Interior").classList.remove('MuiCollapse-hidden');
         document.getElementById("Interior").previousSibling.classList.remove('menuActive');

         document.getElementById("Exterior").previousSibling.classList.remove('menuActive');

      }
      setTimeout(() => {

         const collection = document.getElementsByClassName("menu");
         for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove('active');
         }
      }, 1000);

      window.resetpop();
      window.calloutPositionReset();
      setTimeout(function () {
          window.updateZoomSlider(window.sliderEl3, window.scene._nav.getZoomFactor());
      }, 2000);

   };

   return (
      <div className="menu " id={item.id == 'btnXR' ? arbuttonName : 'menu' + item.id} style={item.id == 'btnXR' ? { 'display': 'none' } : {}}>
         <ListItem button onClick={() => { handleClick(item.id) }}>
            {(window.mob || window.innerHeight > window.innerWidth) ?
               <div className="MuiListItemIcon-root">
                  <img className={`icondiv${item.id}`} src={item.icon} />
               </div>
               : <div className="MuiListItemIcon-root">
               <img className={`icondiv${item.id}`}  />
            </div>
              }
            <div className="title">
               <ListItemText primary={item.id == 'Interior' && (window.mob || window.innerHeight > window.innerWidth) ? 'Explode' : item.title} />
            </div>
         </ListItem>
         <Collapse in={open} id={item.id == 'btnXR' ? 'menubtnxr' : item.id} timeout="auto" >
            <List component="div" >
               {children.map((child, key) => (
                  <MenuItem key={key} item={child} />
               ))}
            </List>
         </Collapse>
      </div>
   );
};
//  export default MultiLevel
